import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const DropdownElementV1 = z.object({
  id: z.string(),
  name: z.literal("dropdown"),
  container: ContainerOptionsV1,
})

export type TDropdownElementV1 = z.infer<typeof DropdownElementV1>

// Latest ---------------------
export const DropdownElement = DropdownElementV1
export type TDropdownElement = TDropdownElementV1
